import { MainWindow } from "../../../MainWindow";

export function Overnight() {
    return <MainWindow currentTab="forms" subtab="overnight">Overnight</MainWindow>;
}